import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import React from "react";
import {FooterFC} from "./types";
import numberFormat from "../../../../utils/formatNumber";

const Footer: FooterFC = ({order, loading}) => {

    return (
        <TableRow>
            <TableCell colSpan={2} align={"right"}>
                {"Итого:"}
            </TableCell>
            <TableCell align={"left"}>
                {order && order.length > 0 && !loading && numberFormat(order.reduce((acc, item) => {
                    return acc + item.periods.reduce((accPeriod, period) => accPeriod + period.turnover.value, 0);
                }, 0), 0)}
            </TableCell>
            <TableCell align={"left"}>
                {order && order.length > 0 && !loading && numberFormat(100)}
            </TableCell>
            <TableCell align={"left"}>
                {order && order.length > 0 && !loading && numberFormat(order.reduce((acc, item) => {
                    return acc + item.periods.reduce((accPeriod, period) => accPeriod + period.marginality.valute, 0);
                }, 0), 0)}
            </TableCell>
            <TableCell align={"left"}>
                {order && order.length > 0 && !loading && numberFormat(100)}
            </TableCell>
            <TableCell align={"left"}>
                {order && order.length > 0 && !loading && numberFormat(order.reduce((acc, item) => {
                    return acc + item.periods.reduce((accPeriod, period) => accPeriod + period.marginality.percent, 0);
                }, 0) / order.reduce((acc, item) => acc + item.periods.length, 0), 1)}
            </TableCell>
            <TableCell align={"left"}>
                {order && order.length > 0 && !loading && numberFormat(order.reduce((acc, item) => {
                    return acc + item.periods.reduce((accPeriod, period) => accPeriod + period.markup, 0);
                }, 0) / order.reduce((acc, item) => acc + item.periods.length, 0), 2)}
            </TableCell>
        </TableRow>
    )
};

export default Footer;
